//lib/fetchWithAuth.ts
import { getAccessToken, setGlobalAccessToken } from './auth-context';
import { toast } from 'sonner';

export async function fetchWithAuth(input: RequestInfo, init: RequestInit = {}) {

  // eslint-disable-next-line prefer-const
  let token = getAccessToken();

  const headers = new Headers(init.headers || {});
  if (token) headers.set('Authorization', `Bearer ${token}`);

  let response = await fetch(input, {
    ...init,
    headers,
    credentials: 'include',
  });

  if (response.status === 401) {
    try {
      const refresh = await fetch(`${process.env.NEXT_PUBLIC_API_BASE}/auth/refresh`, {
        method: 'POST',
        credentials: 'include',
      });

      const data = await refresh.json();

      if (refresh.ok && data.access_token) {
        const newToken = data.access_token;
        headers.set('Authorization', `Bearer ${newToken}`);

        setGlobalAccessToken(newToken); // ✅ update memory + user
        response = await fetch(input, {
          ...init,
          headers,
          credentials: 'include',
        });
        return response;
      } else {
        toast.error('Session expired. Please log in again.');
        window.location.href = '/login';
      }
    } catch {
      toast.error('Session expired. Please log in again.');
      window.location.href = '/login';
    }
  }

  return response;
}
